import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import general from './generalReducer';
import modal from './modalReducer';
import wallet from './walletReducer';
import assets from './assetsReducer';
import nft from './nftReducer';
import champion from './championReducer';
import portfolio from './portfolioReducer';
import createHPool from './createHPoolReducer';
import ui from './uiReducer';

export default combineReducers({
  form,
  ui,
  general,
  modal,
  wallet,
  assets,
  nft,
  champion,
  portfolio,
  createHPool,
});
